import { render, staticRenderFns } from "./expensesRefund.vue?vue&type=template&id=643fed87&scoped=true"
import script from "./expensesRefund.vue?vue&type=script&lang=js"
export * from "./expensesRefund.vue?vue&type=script&lang=js"
import style0 from "./expensesRefund.vue?vue&type=style&index=0&id=643fed87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643fed87",
  null
  
)

export default component.exports